// utilities/errorHandler/checks.ts - utilities/errorHandler.ts split (sub-module checks)

import {
  RETRYABLE_MESSAGES, CHUNK_PATTERNS, NETWORK_PATTERNS, TIMEOUT_PATTERNS, OFFLINE_PATTERNS,
} from './patterns';

/**
 * Determines if an error can be retried
 */
export function isRetryable(error: unknown): boolean {
  const err = error as { message?: string; status?: number };
  const message = err.message?.toLowerCase() ?? '';

  if (RETRYABLE_MESSAGES.some((msg) => message.includes(msg))) return true;
  if (message.includes("timeout") || message.includes("offline")) return true;

  if (typeof err.status === "number") {
    return err.status >= 500 || err.status === 429;
  }

  return false;
}

/**
 * Checks if error is a chunk/module loading error (stale deploy)
 */
export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return CHUNK_PATTERNS.some((pattern) =>
    error.message.toLowerCase().includes(pattern.toLowerCase())
  );
}

/**
 * Checks if error is a network error
 */
export function isNetworkError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return NETWORK_PATTERNS.some((pattern) =>
    error.message.toLowerCase().includes(pattern.toLowerCase())
  );
}

/**
 * Checks if error is a timeout error
 */
export function isTimeoutError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return TIMEOUT_PATTERNS.some((pattern) =>
    error.message.toLowerCase().includes(pattern.toLowerCase())
  );
}

/**
 * Checks if error indicates offline state
 */
export function isOfflineError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return OFFLINE_PATTERNS.some((pattern) =>
    error.message.toLowerCase().includes(pattern.toLowerCase())
  );
}

/**
 * Checks if browser is online
 */
export function isBrowserOnline(): boolean {
  if (typeof navigator !== "undefined") {
    return navigator.onLine;
  }
  return true;
}
